import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Colorfilter.module.css";

const ColorFilter = ({ colors = [] }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);

  const selectedColors = params.getAll("color[]");

  const handleClick = (color) => {
    const params = new URLSearchParams(location.search);

    const selected = params.getAll("color[]");

    if (selected.includes(color)) {
      const updated = selected.filter((c) => c !== color);

      params.delete("color[]");

      updated.forEach((c) => {
        params.append("color[]", c);
      });
    } else {
      params.append("color[]", color);
    }

    navigate(`${location.pathname}?${params.toString()}`);
  };

  // Only colors received from API
  const uniqueColors = [
    ...new Map(
      colors
        .filter((color) => color?.color_name)
        .map((color) => [
          color.color_name.toLowerCase(),
          color,
        ])
    ).values(),
  ];

  return (
    <div className={styles.container}>
      <h4 className={styles.heading}>COLOUR</h4>

      <div className={styles.colorList}>
        {uniqueColors.map((color, index) => {
          const colorName = color.color_name;

          const isActive = selectedColors.some(
            (selected) =>
              selected.toLowerCase() === colorName.toLowerCase()
          );

          return (
            <div
              key={`${colorName}-${index}`}
              onClick={() => handleClick(colorName)}
              className={`${styles.colorItem} ${
                isActive ? styles.active : ""
              }`}
            >
              <input
                type="checkbox"
                checked={isActive}
                onChange={() => handleClick(colorName)}
                onClick={(e) => e.stopPropagation()}
              />

              <span
                className={styles.colorCircle}
                style={{
                  backgroundColor: colorName,
                }}
              />

              <span className={styles.label}>
                {colorName}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ColorFilter;